module.exports = __webpack_public_path__ + "img/icon3.84f7ded5.png";